import { StreamHandler } from "./stream.handler";
import {
  SubscribeTournamentLeaderboards,
  UpdateTournamentLeaderboards,
} from "@/types";
import type { TournamentLeaderboardsSchema } from "@/types";
import { useAppStore } from "@/stores";

/**
 * `tournament_leaderboards` — the tournament-specific volatile stream (the
 * competitor leaderboard per tournament campaign). Twin of
 * `prize-drop-prizes.handler`; feeds `tournamentLeaderboardsById`.
 *
 * Unlike the prize-drop handler it does NOT trigger an assembly recompute — the
 * leaderboard is read directly off its raw slice, never folded into the assembled
 * `Tournament`, so a ~5s board tick re-renders only the leaderboard subtree (see
 * `stores/tournament.store.ts`). Structural data rides `campaigns`; the player's
 * own score rides `tournament_progress`.
 */
export class TournamentLeaderboardsHandler extends StreamHandler<
  TournamentLeaderboardsSchema[]
> {
  protected readonly subscribeType = SubscribeTournamentLeaderboards;
  protected readonly updateType = UpdateTournamentLeaderboards;

  protected isBusy(): boolean {
    const s = useAppStore.getState().tournamentLeaderboardsStream;
    return s.subscribed || s.loading;
  }
  protected setLoading(loading: boolean): void {
    useAppStore.getState().setTournamentLeaderboardsLoading(loading);
  }
  protected setSubscribed(subscribed: boolean): void {
    useAppStore.getState().setTournamentLeaderboardsSubscribed(subscribed);
  }
  protected clear(): void {
    useAppStore.getState().clearTournamentLeaderboards();
  }
  protected apply(data: TournamentLeaderboardsSchema[]): void {
    useAppStore.getState().setTournamentLeaderboards(data);
  }
}

export const tournamentLeaderboardsHandler =
  new TournamentLeaderboardsHandler();
